'use client';

import React from 'react';
import { ButtonCta } from '@/components/ui/ButtonCta';
import { Calculator } from 'lucide-react';

export const MidContentCTA: React.FC = () => {
  return (
    <div className="my-16 bg-gradient-to-r from-neutral-900 to-neutral-800 rounded-lg p-8 lg:p-12">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 rounded-lg bg-blue-100 flex items-center justify-center">
            <Calculator className="w-6 h-6 text-blue-600" />
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold text-white">
            See Your Real Numbers
          </h2>
        </div>

        <p className="text-xl text-white font-semibold mb-6">
          The difference between break-even and $130K profit? Getting the multipliers right.
        </p>

        <p className="text-lg text-neutral-200 mb-4">
          But every market is different:
        </p>

        <ul className="space-y-3 mb-8 text-lg text-neutral-200">
          <li className="flex items-start">
            <span className="text-blue-500 mr-3 mt-1">•</span>
            <span>How much do leads actually cost in your area?</span>
          </li>
          <li className="flex items-start">
            <span className="text-blue-500 mr-3 mt-1">•</span>
            <span>What agent partnership ratios are realistic?</span>
          </li>
          <li className="flex items-start">
            <span className="text-blue-500 mr-3 mt-1">•</span>
            <span>How long before your database starts converting?</span>
          </li>
          <li className="flex items-start">
            <span className="text-blue-500 mr-3 mt-1">•</span>
            <span>What's achievable vs fantasy in your specific market?</span>
          </li>
        </ul>

        <p className="text-lg text-neutral-200 mb-6">
          We'll run your numbers together and show you what's realistic.
        </p>

        <div className="text-center">
          <ButtonCta
            href="/mortgage-lead-generation-demo"
            variant="primary"
            showArrow={true}
            className="w-full sm:w-auto mb-3"
          >
            Schedule Your Strategy Session
          </ButtonCta>

          <p className="text-sm text-neutral-300">
            Model your specific market and situation
          </p>
        </div>
      </div>
    </div>
  );
};
